import Render from 'components/render';
import { VANILLA_SETTLING_ASSET } from 'constants/constants';
import { sortBalancesBySortPriority } from 'helpers/utils';
import i18n from 'i18n/config';
import { enableWalletsSelector } from 'selectors/walletSelector';
import { useAppSelector } from 'storeHooks';
import Box from 'UIKit/Box';

import { UnrealisedCashflow } from '../computeTotalBalance';
import styles from './indianWallet.module.scss';
import TooltipWrapper from './TooltipWrapper';

const headerUnrealisedCashflow = i18n.t('headerFooter:header.wallet.unrealisedCashflows');
const unrealisedCashflowPopOverIndianExchange = i18n.t(
  'headerFooter:header.wallet.unrealisedCashflowPopOverIndianExchange'
);

const UnRealisedCashflow = ({ showAmount }: { showAmount: boolean }) => {
  const balances = useAppSelector(enableWalletsSelector);

  const balanceArray = sortBalancesBySortPriority(balances);
  const coinBalance =
    balanceArray.find(coin => coin.asset.symbol === VANILLA_SETTLING_ASSET) ?? {};

  return (
    (<div
      className={styles['label-value-container']}
      data-palette="UnRealisedCashflow">
      <div className={styles.label}>
        <TooltipWrapper
          title={headerUnrealisedCashflow}
          body={unrealisedCashflowPopOverIndianExchange}
        />
      </div>
      <div className={styles.value}>
        <Box as="span" className={styles.inr}>
          <Render when={showAmount} else="******">
            ₹<UnrealisedCashflow coinBalance={coinBalance} returnInInr />
          </Render>
        </Box>
        <Box className={styles.usd}>
          <Render when={showAmount} else="******">
            $<UnrealisedCashflow coinBalance={coinBalance} />
          </Render>
        </Box>
      </div>
    </div>)
  );
};

export default UnRealisedCashflow;
